import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import langInvestWordLang from '../../../apps/investor/langs/langInvestWordLang';

type AppFormatDateProps = {
	date?: Date | string | null;
};

const AppFormatDate = (props: AppFormatDateProps) => {
	const { date } = props;
	const { t } = useTranslation();
	return <>{date ? moment(date).format('DD/MM/YYYY') : t(langInvestWordLang.nc.tag)}</>;
};

export default AppFormatDate;
